module.exports = __webpack_public_path__ + "static/media/p33.e2f19c3d.jpg";